const parseBoldText = (text: string): (string | JSX.Element)[] => {
    const parts = text.split('*');
    return parts.map((part, index) =>
        index % 2 === 1 ? <strong key={index}>{part}</strong> : part
    );
}

export default parseBoldText;